import React, { useState } from 'react';
import { Shelf } from 'types';
import Input from '../form/input';
import InputLabel from '../input-label';
import Button from '../button';
import styles from '../../styles/components/shelves-modals.module.scss';
import useAnalytics from '../../lib/hooks/use-analytics';

export default function ShareModal({ shelf }: { shelf: Shelf; }) {
  const [email, setEmail] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);

  const { analyticEvents } = useAnalytics();

  const sendEmail = async () => {
    //create sendgrid email for this?
    window.open(
      `mailto:${email}
      ?subject=Check out this shelf on Shelf!
      &body=Hey! I wanted to share this shelf I made on PangoBooks. Check it out: ${window.location}
      `
    );

    analyticEvents.shareShelf({ type: 'email' });
  };

  const copyLink = async () => {
    navigator.clipboard.writeText(`${window.location}`);
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 3500);

    analyticEvents.shareShelf({ type: 'link' });
  };

  return (
    <div>
      <InputLabel>Share shelf with your friends</InputLabel>
      <div className={styles['share-container']}>
        <Input
          type='email'
          name='email'
          placeholder='Enter email'
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          required
        />
        <div className={styles['share-button']}>
          <Button onPress={sendEmail} text='Send' disabled={!email} />
        </div>
      </div>
      <InputLabel>Shareable link</InputLabel>
      <div className={styles['share-container']}>
        <Input
          type='text'
          name='shareable-link'
          placeholder='Share link'
          value={`${window.location}`}
          readOnly
          onChange={null}
        />
        <div className={styles['share-button']}>
          <Button
            onPress={copyLink}
            text={linkCopied ? 'Copied!' : 'Copy link'}
          />
        </div>
      </div>
    </div>
  );
}
